import { useAddressSearch } from '@gov-nx/core/hooks';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useProfilROBReklamaceContextInstance } from '@gov-nx/module/page';
import { Button, FormInput, FormSelect } from '@gov-nx/ui/web';

export interface AddressFormProps {
	code: PageCode;
	isProcessing: boolean;
}

export const AddressSearchForm = ({ code, isProcessing }: AddressFormProps) => {
	const { address, mainQuery, formDefinition, setControls, controls } =
		useProfilROBReklamaceContextInstance();
	const { form } = formDefinition;
	const { disableSearchButton } = useAddressSearch({
		formMethods: form.formMethods,
	});
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(code);

	return (
		<>
			<FormInput {...form.fields.nazevObce} />
			<FormInput {...form.fields.nazevUlice} />
			<FormInput {...form.fields.cislo} />
			<Button
				onClick={() => {
					mainQuery.refetch();
					setControls({ displaySearchAddressLoading: true });
				}}
				isDisabled={disableSearchButton || isProcessing}
				isLoading={controls.displaySearchAddressLoading}
				nativeType="button"
				color="primary"
				size="m"
				type="outlined">
				{ts('akce.vyhledat')}
			</Button>
			{mainQuery.isSuccess && (
				<FormSelect
					{...form.fields.newAddress}
					field={{
						...form.fields.newAddress.field,
						children: (
							<>
								<option
									value=""
									disabled>
									{ts('formular.pole.neuvedeno')}
								</option>
								{address.map((address) => (
									<option
										value={address.kod}
										key={address.kod}>
										{address.adresaText}
									</option>
								))}
							</>
						),
					}}
				/>
			)}
		</>
	);
};
